export default "__VITE_ASSET__DnjCMD1Q__"